const featureAvailability = function(featureName, development, staging, production){
  this.feature = featureName;
  this.development = development;
  this.staging = staging;
  this.production = production;
};

//TODO take these out
module.exports = [
  new featureAvailability('dummy',                           false,  false,  false)
];